import React, { useEffect, useRef } from "react";
import Button from "../../components/common/ui/Button";
import Table from "../../components/common/table/Table";
import { useState } from "react";
import { history } from "../../_helpers";
import { useLocation } from "react-router-dom";
import Error from "../error/error";
import { useDispatch, useSelector } from "react-redux";
import {
  authActions,
  inmateAction,
  masterActions,
  photoAction,
  publicUserActions,
} from "../../_store";
import CustomLoader from "../../components/common/ui/Loader";
import { Popup } from "../../components/common/ui/NotificationModal/Popup";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import ApproveImg from "../../assets/svg/approve-icon.svg";
import RejectImg from "../../assets/svg/reject.svg";
import { StoredProcedures } from "../../_helpers/enumerator";
import {
  fDate,
  fDateTimeSuffix,
  formatDateTimeAMPM,
} from "../../utils/formatTime";
import useManagementUserAccessPermission from "../../hooks/useManagementUserAccessPermission";
import { getStoredValue } from "../../_helpers/storagehelper";
import CustomPhoto from "../../composables/CustomPhoto";

function PhotoInformation() {
  const dispatch = useDispatch();
  const location = useLocation();

  const searchData = location?.state ? location?.state?.searchList : {};

  const reviewName = location?.state ? location?.state?.name : "";

  const [updateCommID, setUpdateCommID] = useState(0);
  const [selectedPhoto, setSelectedPhoto] = useState("");
  const [isZoom, setIsZoom] = useState(false);
  const [isIndexValueFlag, setIsIndexValueFlag] = useState(false);
  const photoCommID = location?.state?.photoCommID ? location?.state?.photoCommID : updateCommID;
  const [isloading, setisloading] = useState(false);
  const [isimgloading, setisimgloading] = useState(true);
  const { source, Inmate, row } = location.state || {};
  const { isSignalRData } = useSelector((state) => state.auth);

  const {
    photoInfo,
    loading,
    updateStatusResponse,
    photoReviewList,
    photosList,
    LoadReviewALLPhotosListData,
    photosSearchData,
  } = useSelector((x) => x?.photos);

  const { commonFacilityCode } = useSelector((state) => state.auth);
  const prevFacilityCodeRef = useRef(commonFacilityCode);

  const user = useSelector((x) => x.auth.user);
  const [rotation, setRotation] = useState(0);

  const [indexValue, setIndexValue] = useState(0);

  const [approveRejectStatus, setApproveRejectStatus] = useState({
    photoCommID: photoCommID,
    facilityID: commonFacilityCode,
    photoApprove: 0,
    photoReject: 0,
    createdBy: getStoredValue("user")?.ManagementUserID,
  });

  const { accessPermission } = useManagementUserAccessPermission();

  // Hide or Show Upload btn
  const ShowButtonApproveReject =
    Array?.isArray(accessPermission) && accessPermission?.length > 0
      ? accessPermission?.some(
        (item) => item?.SubMenuID === 23 && item?.SubMenuActiveStatus === 1
      ) // Review
      : true;


  useEffect(() => {
    if (prevFacilityCodeRef.current !== commonFacilityCode) {
      history.navigate("PhotoList");
    }
  }, [commonFacilityCode]);

  /* facility drop down */
  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({ facilityID: 0, activeStatus: 1 })
    );
  }, []);

  //signalR
  useEffect(() => {
    if (isSignalRData?.type == "Read_Photo" && photoInfo?.PhotoCommID == isSignalRData?.message?.PhotoAccess) {
      dispatch(photoAction?.setPhotoInformation({ ...photoInfo, PhotoReadStatus: "Photo Read" }));
    }
  }, [isSignalRData]);

  useEffect(() => {
    if (reviewName) {
      const filteredData = photoReviewList[indexValue];
      setUpdateCommID(filteredData?.PhotoCommID || 0);
      dispatch(photoAction?.setPhotoInformation(filteredData));
    }
  }, [reviewName, photoReviewList, indexValue, dispatch]);

  useEffect(() => {
    if (
      source === "photoList" &&
      reviewName === "ReviewPhotos" &&
      Object?.keys(LoadReviewALLPhotosListData)?.length === 0
    ) {
      history?.navigate("PhotoList");
    }
  }, [source, reviewName]);

  useEffect(() => {
    if (
      reviewName &&
      LoadReviewALLPhotosListData?.DataList?.length > 1 &&
      photoInfo?.IsPhotoApprove === 1
    ) {
      handlePrevNext("next");
    }
  }, [reviewName, LoadReviewALLPhotosListData, photoInfo]);

  useEffect(() => {
    if (photoCommID > 0 && !reviewName) {
      dispatch(photoAction?.getPhotosInfo(photoCommID));
      return;
    } else {
      if (Object?.keys(LoadReviewALLPhotosListData)?.length !== 0) {
        if (isIndexValueFlag) {
          setIsIndexValueFlag(false);
          return;
        }
        const commID = LoadReviewALLPhotosListData?.DataList?.[indexValue]?.PhotoCommID;
        // const commID = photoCommID;
        dispatch(photoAction?.getPhotosInfo(commID))
          .then((result) => {
            const list = result?.payload;
            const updateStatus = { ...approveRejectStatus };
            updateStatus["photoCommID"] = list?.PhotoCommID;
            setApproveRejectStatus(updateStatus);
          })
          .catch((err) => { });
      }
    }
  }, [indexValue, photoCommID]);

  const handleshowtoast = (item) => {
    switch (item?.IsSucceed) {
      case 1:
        // Insert Management User Activity Log
        dispatch(
          authActions?.ManagementUserActivityLog({
            ManagementUserID: user?.ManagementUserID,
            facilityID: commonFacilityCode,
            ProcedureName: StoredProcedures?.PhotoApproveOrReject,
            UserAction: `Approved Photo ( PhotoCommID - ${photoCommID} )`,
          })
        );
        MultipleReviewPhotos();
        showToastNotification("Photo Approved Successfully.", "success");
        dispatch(photoAction.resetForm());
        break;

      case 2:
        // Insert Management User Activity Log
        dispatch(
          authActions?.ManagementUserActivityLog({
            ManagementUserID: user?.ManagementUserID,
            facilityID: commonFacilityCode,
            ProcedureName: StoredProcedures?.PhotoApproveOrReject,
            UserAction: `Rejected Photo ( PhotoCommID - ${photoCommID} )`,
          })
        );
        // history.navigate("/Admin/PhotoList");
        MultipleReviewPhotos();
        showToastNotification("Photo rejected Successfully..", "success");
        dispatch(photoAction.resetForm());
        break;

      case -1:
        history.navigate("/Admin/PhotoList");
        showToastNotification("Insert Failed", "error");
        dispatch(photoAction.resetForm());
        break;

      case -2:
        history.navigate("/Admin/PhotoList");
        showToastNotification("Already Approved or Rejected.", "error");
        dispatch(photoAction.resetForm());
        break;

      case -3:
        showToastNotification("Photo already approved.", "error");
        // if (LoadReviewALLPhotosListData?.DataList?.length > 1 && reviewName) {
        //   MultipleReviewPhotos();
        // } else {
        history.navigate("/Admin/PhotoList");
        dispatch(photoAction.resetForm());
        // }
        break;

      case -4:
        showToastNotification("Photo already Rejected.", "error");
        // if (LoadReviewALLPhotosListData?.DataList?.length > 1 && reviewName) {
        //   MultipleReviewPhotos();
        // } else {
        history.navigate("/Admin/PhotoList");
        dispatch(photoAction.resetForm());
        // }
        break;

      default:
        break;
    }
  };

  const handleZoom = (photo) => {
    setSelectedPhoto(photo);
    setIsZoom(true);
  };

  const MultipleReviewPhotos = () => {
    if (reviewName) {
      setisloading(true);
      // handlePrevNext("next");
      const filer = { ...photosSearchData };
      filer.rowCountPerPage = 10000;
      filer.pageNo = 1;
      filer.sortBy = "PhotoCommID asc";
      filer.photoActionStatus = 3;
      dispatch(photoAction?.getPhotosList(filer))
        .then((result) => {
          const photoCount = result?.payload?.TotalRecordCount;
          if (photoCount <= 0) {
            const searchData = { ...photosSearchData };
            searchData.facilityID = commonFacilityCode;
            //searchData.pageNo = 1;
            // searchData.rowCountPerPage = 10;
            dispatch(photoAction?.setPhotosSearch(searchData));
            history.navigate("/Admin/PhotoList");
          } else {
            let indexValueFlag = indexValue;
            if (indexValue >= result?.payload?.DataList.length) {
              indexValueFlag = 0;
              setIsIndexValueFlag(true);
              setIndexValue(() => 0);
            }
            const commID =
              result?.payload?.DataList?.[indexValueFlag]?.PhotoCommID;
            setUpdateCommID(commID);
            dispatch(
              photoAction?.setPhotoInformation(
                result?.payload?.DataList?.[indexValueFlag]
              )
            );
            setisloading(false);
            setRotation(0);
          }
        })
        .catch((err) => {
          showToastNotification("Error in fetching data", "error");
        });
    } else {
      const searchData = { ...photosSearchData };
      searchData.facilityID = commonFacilityCode;
      //searchData.pageNo = 1;
      // searchData.rowCountPerPage = 10;
      dispatch(photoAction?.setPhotosSearch(searchData));
      history.navigate("/Admin/PhotoList");
    }
  };

  const handlePrevNext = (direction) => {
    setisimgloading(true);
    setRotation(0);
    if (
      direction === "next" &&
      LoadReviewALLPhotosListData?.DataList?.length === indexValue + 1
    ) {
      setIndexValue(() => 0);
      return;
    }

    if (direction === "prev" && indexValue === 0) {
      const prevPhoto = LoadReviewALLPhotosListData?.DataList?.length - 1;
      setIndexValue(() => (prevPhoto >= 0 ? prevPhoto : 0));
      return;
    }

    setIndexValue((prev) => (direction === "next" ? prev + 1 : prev - 1));
  };

  const data = [
    {
      label: "Subject",
      value: photoInfo?.PhotoSubject || "",
    },
    { label: "From", value: photoInfo?.PhotoFrom || "-" },
    { label: "To", value: photoInfo?.PhotoTo || "-" },
    { label: "Sent On", value: photoInfo?.PhotoSentDate || "-" },
    { label: "Action Status", value: photoInfo?.PhotoActionStatus || "-" },
    { label: "Read Status", value: photoInfo?.PhotoReadStatus || "-" },
    {
      label: "Approve/Rejected By",
      value: photoInfo?.ApproveOrRejectName || "-",
    },
    {
      label: "Approve/Rejected Date",
      // value: photoInfo?.ApproveOrRejectDate || "-",
      value: formatDateTimeAMPM(photoInfo?.ApproveOrRejectDate) || "-",
    },
    { label: "Sent IP", value: photoInfo?.PhotoSentIPAddress || "-" },
  ];

  const columns = [
    {
      width: "180px",
      name: "PHOTO DESCRIPTION",
      selector: (row) => row.label,
      sortable: false,
      cell: (row) => (
        <div className="doc-name">
          <div>{row.label}</div>
        </div>
      ),
    },
    {
      name: "",
      selector: (row) => row.value,
      sortable: false,
    },
  ];

  // Function to handle rotation
  const rotateImage = (angle) => {
    setRotation((prevRotation) => prevRotation + angle);
  };

  const handleApproveStatus = (e, status) => {

    const shouldEnableBtn =
      Array.isArray(accessPermission) && accessPermission?.length > 0
        ? accessPermission?.some(
          (item) =>
            item?.SubMenuName === "Review" &&
            item?.SubMenuActiveStatus === 1
        )
        : true;
    if (!shouldEnableBtn) {
      showToastNotification(
        "Review option has been disabled by the admin.",
        "error"
      );
      return;
    }
    const { name } = e?.target;
    const updateStatus = { ...approveRejectStatus };
    if (name?.trim()?.length == 0) { return; }
    updateStatus[name] = 1;
    updateStatus[
      name == "photoApprove" ? "photoReject" : "photoApprove"
    ] = 0;
    setApproveRejectStatus(updateStatus);

    Popup({
      title: "Message",
      text: `Are you sure you want to ${status == "approve" ? "Approve" : "Reject"
        }?`,
      icon: "info",
      confirmButtonText: "Ok",
      cancelButtonText: "Cancel",
      onConfirm: async () => {
        try {
          setisloading(true);
          const response = await handlePhotoUpdate(updateStatus);
          setisloading(false);
          handleshowtoast(response?.payload);
          const search = {
            ...photosSearchData,
            pageNo: 1,
            rowCountPerPage: photosList?.TotalRecordCount,
            photoActionStatus: 3,
            isReviewPhotos: true,
          };
          dispatch(photoAction?.LoadReviewALLPhotosList(search)).then(
            (result) => {
              // const photoCount = result?.payload?.TotalRecordCount;
              const reviewData = result?.payload?.DataList;
              const updateIndex = indexValue ? indexValue : 0;
              const commID = reviewData?.[updateIndex]?.PhotoCommID;
              if (!commID) return;
              dispatch(photoAction?.getPhotosInfo(commID)).then(
                (result) => {
                  const list = result?.payload;
                  const updateStatus = { ...approveRejectStatus };
                  updateStatus["photoCommID"] = list?.PhotoCommID;
                  setApproveRejectStatus(updateStatus);
                }
              );
            }
          );
          dispatch(
            masterActions.GetLoadNotificationAlert({
              ManagementUserID: user.ManagementUserID,
              FacilityID: commonFacilityCode,
            })
          ).then((response) => {
            const updatedMenuList =
              getStoredValue("menu_list") ||
              response?.payload;

            if (updatedMenuList) {
              dispatch(authActions.updateMenuList(updatedMenuList));
            }
          });

        }
        catch (error) {
          console.error("Error updating photo status:", error);
        }
      },
    });

  };


  const handlePhotoUpdate = async (updateStatus) => {
    if (photoInfo?.IsPhotoApprove === 1) {
      return await dispatch(photoAction?.updateStatusPhotosReject(updateStatus));
    } else {
      return await dispatch(photoAction?.updateStatus(updateStatus));
    }
  };

  const handleBack = () => {
    if (source === "publicUserPhoto" && source !== "" && source !== undefined) {
      history.navigate("PublicUserList/Details", {
        state: { row: row },
      });
      dispatch(publicUserActions?.setPublicUserTab("publicuser-photos-tab"));
    } else if (source === "InmatePhotos") {
      history.navigate("InmateList/Details", {
        state: { inmate: Inmate, showTransactionTab: false },
      });
      dispatch(inmateAction.setInmateCurrentTab("inmate-photos-tab"));
    } else {
      history?.navigate("PhotoList");
      const searchData = { ...photosSearchData };
      searchData.facilityID = commonFacilityCode;
      //  searchData.pageNo = 1;
      //searchData.rowCountPerPage = 10;
      dispatch(photoAction?.setPhotosSearch(searchData));
    }
  };

  if (loading || isloading) return <CustomLoader />;

  const handleImageLoad = () => {
    setisimgloading(false);
  }


  return (
    <>
      <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">
        <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap resp-space">
          <h2 className=" text-color">PHOTO INFORMATION</h2>
          <div className="d-flex flex-wrap">
            <Button
              label="Back"
              type="button"
              //className="btn btn-danger me-2"
              onClick={() => handleBack()}
              variant="danger"
              status={"primary"}
              disabled={false}
              icon={"fa-solid fa-angle-left"}
            />
          </div>
        </div>
        {photoInfo?.IsPhotoApprove === 1 && (
          <div
            className="mt-3 fs-5 fst-italic fw-bold"
            style={{ color: "#e86a6a" }}
          >
            If you want to Reject an already Approved photo, click Reject button
            below.This will not affect the revenue reporting.
          </div>
        )}
        {(photoInfo?.InmateStatus == 0) && (
          <div
            className="mt-3 fs-5 fst-italic fw-bold"
            style={{ color: "#e86a6a" }}
          >
            The inmate has already been released.Kindly reject the photo.
          </div>
        )}

        <div className="row mt-3 resp-space">
          <div className="col-md-6 d-flex flex-wrap justify-content-center gap-3 resp-space">
            {(photoInfo?.IsPhotoReject === 0 || photoInfo?.InmateStatus == 0) && (
              <>
                {ShowButtonApproveReject && (
                  // {photosList?.DataList?.length > 1  && }
                  <>
                    {(photoInfo?.IsPhotoApprove === 0 && photoInfo?.InmateStatus == 1) && (
                      <Button
                        className="me-2"
                        label="Approve"
                        name="photoApprove"
                        type="submit"
                        variant="danger"
                        imgsrc={ApproveImg}
                        status={"success"}
                        onClick={(e) => handleApproveStatus(e, "approve")}
                      />
                    )}

                    <Button
                      className="me-2"
                      name="photoReject"
                      label="Reject"
                      type="reset"
                      variant="danger"
                      status={"primary"}
                      imgsrc={RejectImg}
                      onClick={(e) => handleApproveStatus(e, "reject")}
                    />
                  </>
                )}
              </>
            )}
          </div>
          {reviewName && (
            <div className="col-md-6 d-flex flex-wrap justify-content-center align-items-center gap-3">
              {LoadReviewALLPhotosListData?.DataList?.length > 1 && (
                <>
                  <i
                    className={`fas fa-arrow-alt-circle-left fs-2 cursor-pointer`}
                    // ${
                    //   indexValue === 0 ? "disabled-icon" : ""
                    // }`}
                    onClick={() => handlePrevNext("prev")}
                    title="prev"
                  ></i>

                  <i
                    // disabled={photoReviewList?.length === indexValue + 1}
                    className={`fas fa-arrow-alt-circle-right fs-2 cursor-pointer`}
                    //  ${
                    //   photosList?.DataList?.length === indexValue + 1
                    //     ? "disabled-icon"
                    //     : ""
                    // }`}
                    onClick={() => handlePrevNext("next")}
                    title="next"
                  />
                </>
              )}
            </div>
          )}
        </div>

        <div className="row mt-3">
          {/* {rotation} */}
          <div className="col-md-6 col-lg-6 col-sm-12 p-2 border border-dark-grey">
            <div className="fs-5 px-4 py-3 d-flex flex-wrap justify-content-center">
              {/* Rotate Left Icon */}
              <i
                className="fas fa-lg fa-fw me-10px fa-rotate-right"
                onClick={() => rotateImage(90)}
                style={{ cursor: "pointer" }}
                title="Rotate 90°"
              ></i>
              <i
                className="fas fa-lg fa-fw me-10px fa-arrows-rotate"
                onClick={() => rotateImage(180)}
                style={{ cursor: "pointer" }}
                title="Rotate 180°"
              ></i>
              {/* Rotate Right Icon */}
              <i
                className="fas fa-lg fa-fw me-10px fa-rotate-left"
                onClick={() => rotateImage(-90)}
                style={{ cursor: "pointer" }}
                title="Rotate -90°"
              ></i>
            </div>

            <div className="card-body p-2">
              {/* Rotatable Image */}
              <div className="d-flex justify-content-center align-items-center p-2"
              // style={{
              //   position: "relative",
              //   height: "100%",
              //   overflow: "hidden",
              //   margin: "0 auto",
              // }}
              >
                {/* Stretched Image */}

                <img
                  style={{
                    transform: `rotate(${rotation}deg)`,
                    height: '100%',
                    objectFit: 'contain', // Ensures the full image is displayed
                    marginTop: '0', // Adjust margin if needed
                    maxHeight: '50vh',
                    minHeight: '50vh',
                    minWidth: '55vh', maxWidth: '55vh'
                  }}
                  onLoad={handleImageLoad}
                  src={
                    photoInfo?.IsPhotoBinarySave == 1 ?
                      "data:image/png;base64," + photoInfo?.PhotoBinaryData : photoInfo?.PhotoAttachPath
                  }
                  onClick={() =>
                    handleZoom(photoInfo)
                  }
                  alt="photos"
                />
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-6 col-sm-12 p-2 border border-dark-grey">
            <div className="card-body">
              <Table columns={columns} data={data} />
            </div>
          </div>
        </div>
      </div >
      {/* {isimgloading && <CustomLoader />} */}
      <CustomPhoto
        imgsrc={
          selectedPhoto?.IsPhotoBinarySave == 1 ? "data:image/png;base64," + selectedPhoto?.PhotoBinaryData : selectedPhoto?.PhotoAttachPath
        }
        isZommImage={isZoom}
        setisZommImage={setIsZoom}
        rotation={rotation}
        setRotation={setRotation}
      />
      {
        photoInfo?.PhotoExifInfo && (
          <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100 mb-4">
            <h2 className=" text-color ">Exif Information</h2>
            <div
              dangerouslySetInnerHTML={{ __html: photoInfo?.PhotoExifInfo }}
            ></div>
          </div>
        )
      }
    </>
  );
}

export default React.memo(PhotoInformation);
